export { default as IProperty } from './IProperty'
